import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
interface WishlistContextValue {
  ids: string[];
  has: (id: string) => boolean;
  toggle: (id: string) => boolean;
}
const STORAGE_KEY = 'ep-wishlist';
const WishlistContext = createContext<WishlistContextValue | null>(null);
function readStorage(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) as string[] : [];
  } catch {
    return [];
  }
}
export function WishlistProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [ids, setIds] = useState<string[]>(readStorage);
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch {
      /* stockage indisponible */
    }
  }, [ids]);
  const has = useCallback((id: string) => ids.includes(id), [ids]);
  const toggle = useCallback((id: string) => {
    const willAdd = !ids.includes(id);
    setIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
    return willAdd;
  }, [ids]);
  const value = useMemo(() => ({
    ids,
    has,
    toggle
  }), [ids, has, toggle]);
  return <WishlistContext.Provider value={value} data-id="element-637" data-mp="12bdbt0gx5yuh">{children}</WishlistContext.Provider>;
}
export function useWishlist(): WishlistContextValue {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist doit être utilisé dans WishlistProvider');
  return ctx;
}